import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { LabellingCuboid } from '@/types';
import { toNumber3 } from '@/utils/geometry';
import { notEmpty } from '@/utils';
import * as state from '@/components/AssetLabelling/state';
import * as globalState from '@/state';
import { Cuboid, useGetCuboidsByZoneIdLazyQuery } from '@/__generated__/graphql';

const labellingCuboidFromDatabaseCuboid = (databaseCuboid: Cuboid | null | undefined) => {
  if (!databaseCuboid) return undefined;

  const { id, structureId, zoneId, cuboidClassId, position, rotation, scale } = databaseCuboid;
  if (!zoneId) return undefined;
  if (!cuboidClassId) return undefined;

  const labellingCuboid: LabellingCuboid = {
    id,
    structureId: structureId ?? '',
    zoneId,
    cuboidClassId,
    position: toNumber3(position),
    rotation: toNumber3(rotation),
    scale: toNumber3(scale),
  };
  return labellingCuboid;
};

export const useCuboidSubscriptions = () => {
  const selectedZone = useAtomValue(globalState.selectedZone);
  const setCuboids = useSetAtom(state.cuboids);

  const [getCuboidsByZoneId, { data }] = useGetCuboidsByZoneIdLazyQuery({
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!selectedZone) return;

    getCuboidsByZoneId({
      variables: {
        zoneId: selectedZone.id,
      },
    });
  }, [selectedZone, getCuboidsByZoneId]);

  useEffect(() => {
    setCuboids((current) => {
      const newCuboids = current.asMutableStateMap();
      newCuboids.clear();
      data?.cuboidsByZoneId
        .map(labellingCuboidFromDatabaseCuboid)
        .filter(notEmpty)
        .forEach((cuboid) => newCuboids.set(cuboid.id, cuboid));
      return newCuboids?.asStateMap();
    });
  }, [data, setCuboids]);
};
